import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';

import { retryReceiptExtraction } from '../apis/uploadedReceiptApi';

import { useInvalidateBulkOperation } from './useInvalidateImport';

/**
 * Hook for retrying text extraction on all failed receipts in a bulk operation
 */
export const useRetryAllExtractions = (bulkOperationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { invalidateAll } = useInvalidateBulkOperation(bulkOperationId);

  const retryAllMutation = useMutation({
    mutationFn: async (receiptIds: string[]) => {
      const token = await getAccessTokenSilently();
      await Promise.allSettled(
        receiptIds.map(id => retryReceiptExtraction(id, token))
      );
    },
    onSuccess: () => {
      invalidateAll();
    },
  });

  return {
    retryAllExtractions: retryAllMutation.mutateAsync,
    isRetryingAll: retryAllMutation.isPending,
  };
};
